export default {
    numericOnly: true,
    blocks: [5]
}